export default __webpack_public_path__ + "static/media/contactsNavy.5da6e9ca.svg";